import * as _ from 'lodash';

/* Formato de especificação de env. Esse é o arquivo base e deve
   conter conteúdo usado por todos os ambientes. Os ambientes específicos
   devem sobrescrever o que for necessário */

export interface AppHostConfig {
  host?: string;
  protocol?: string;
  port?: string;
  root?: string;
  unauthenticated?: boolean;
  endpoints?: {
    [ name: string ]: string;
  };
}

export interface AppEnvironment {
  production: boolean;
  time?: number;
  default?: string;
  app?: 'capes-egresso';
  hosts?: {
    [ name: string ]: AppHostConfig
  };
  values?: any;
  idClientId?: string;
  clientId?: string;
}

export const environment: AppEnvironment = {
  production: false,
  hosts: {
    egresso: {
      host: '',
      protocol: '',
      port: '',
      root: '/v1/',
      endpoints: {
        candidatos: 'candidatos',
        'candidatos/selecionar': 'candidatos/selecionar/:id',
        'seguranca/redirect': 'seguranca/redirect/login',
        'seguranca/oauth': 'seguranca/oauth',
        'candidatos/idioma': 'candidatos/idioma/:id',
        'candidatos/formacao': 'candidatos/formacao/:id',
        'candidatos/projeto': 'candidatos/projeto/:id',
        'candidato/id': 'candidatos/:id',
        'candidatos/telefone': 'candidatos/telefone/:id',
        'candidatos/email': 'candidatos/email/:id',
        'candidatos/areas': 'candidatos/areas/:id',
        'candidatos/upload': 'candidatos/upload/:id',
        'candidatos/render': 'candidatos/render/:filename',
        'candidatos/favorito': 'candidatos/favorito/:id',
        'candidatos/questionario': 'candidatos/questionario/:id',
        'candidatos/perfil': 'candidatos/perfil/:id',
        'areas-conhecimentos': 'areas-conhecimentos',
        'agencias-fomento': 'agencias-fomento',
        paises: 'paises',
        municipios: 'municipios',
      }
    }
  },
  values: {
    'redirect-app': 'apptalentos://app/seguranca/login',
    'redirect-pwa': 'https://egressos-des.cloud.capes.gov.br/tabs/login',
    profile: 'capes',
  },
};

export function merge(...env: AppEnvironment[]): AppEnvironment {
  return _.merge({}, environment, ...env);
}
